/**
 * Wrapper classes and custom properties for Progress Bar.
 *
 * MIRRORS PHP: `render.php` computes the same class list and the same custom
 * properties. This block renders on the server, so the editor is the copy —
 * where the two could disagree, the frontend wins.
 */

import { resolvePresetValue } from '../../utils/helpers';

/**
 * Value as a percentage of max, clamped to the track.
 *
 * @param {number} value Current value.
 * @param {number} max   Full-scale value.
 * @return {number} Percentage between 0 and 100.
 */
export function getPercent(value, max) {
  const ceiling = Math.max(1, Number(max) || 100);
  const clamped = Math.min(Math.max(0, Number(value) || 0), ceiling);
  return Math.round((clamped / ceiling) * 10000) / 100;
}

/**
 * @param {Object} attributes Block attributes.
 * @return {string} Wrapper class list.
 */
export function getWrapperClasses(attributes) {
  return ['brandy-progress-bar', attributes.rounded ? 'is-rounded' : '']
    .filter(Boolean)
    .join(' ');
}

/**
 * @param {Object} attributes Block attributes.
 * @return {Object} React style object.
 */
export function getWrapperStyles(attributes) {
  const { value, max, height, duration, barColor, trackColor } = attributes;

  const styles = {
    '--brandy-progress-height': `${height}px`,
    '--brandy-progress-fill': `${getPercent(value, max)}%`,
    '--brandy-progress-duration': `${duration}ms`,
  };

  if (barColor) {
    styles['--brandy-progress-bar-color'] = resolvePresetValue(barColor);
  }

  if (trackColor) {
    styles['--brandy-progress-track-color'] = resolvePresetValue(trackColor);
  }

  return styles;
}
